import React, { useEffect } from "react";
import styled from "styled-components";
import Map from "./Map";
import AmbulanceList from "./AmbulanceList";
import DashboardHeader from "./DashboardHeader";
import NavigationBar from "./NavigationBar";
import Footer from "./Footer";
import useAmbulances from "../hooks/useAmbulances";

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: var(--background-primary);
`;

const DashboardContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  flex: 1;
  overflow: hidden;
  background-color: var(--background-primary);
`;

const ContentContainer = styled.div`
  display: flex;
  flex: 1;
  gap: 20px;
  height: calc(100% - 100px);
  overflow: hidden;
`;

const MapSection = styled.div`
  flex: 3;
  height: 100%;
`;

const ListSection = styled.div`
  flex: 1;
  min-width: 320px;
  max-width: 400px;
  height: 100%;
`;

const DebugOverlay = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 10px;
  font-family: monospace;
  font-size: 12px;
  max-width: 400px;
  max-height: 300px;
  overflow: auto;
  z-index: 1000;
  display: ${process.env.NODE_ENV === "development" ? "block" : "none"};
`;

const Dashboard: React.FC = () => {
  const {
    ambulances,
    loading,
    error,
    ambulanceCount,
    formattedNextETA,
    nextAmbulanceArrivalTime,
    ambulancesWithLocation,
    audioEnabled,
    toggleAudio,
  } = useAmbulances();

  // Get the version from package.json
  const version = process.env.REACT_APP_VERSION || "0.1.0";

  // Debug logs for ambulance status
  useEffect(() => {
    if (ambulances.length > 0) {
      console.log("Dashboard received ambulances:", ambulances);
      console.log(
        "Ambulances with isNew flag:",
        ambulances.filter((a) => a.isNew)
      );
    }
  }, [ambulances]);

  return (
    <PageContainer>
      <NavigationBar />

      <DashboardContainer>
        <DashboardHeader
          ambulanceCount={ambulanceCount}
          ambulancesWithLocation={ambulancesWithLocation}
          nextAmbulanceETA={formattedNextETA}
          nextAmbulanceArrivalTime={nextAmbulanceArrivalTime}
          loading={loading}
          audioEnabled={audioEnabled}
          onToggleAudio={toggleAudio}
        />

        <ContentContainer>
          <MapSection>
            <Map ambulances={ambulances} />
          </MapSection>

          <ListSection>
            <AmbulanceList ambulances={ambulances} loading={loading} />
          </ListSection>
        </ContentContainer>

        {error && (
          <div style={{ color: "var(--error-color)", marginTop: "10px" }}>
            Error: {error}
          </div>
        )}
      </DashboardContainer>

      {/* Add the Footer component */}
      <Footer version={version} />

      {/* Debug overlay in development mode */}
    </PageContainer>
  );
};

export default Dashboard;
